export const EIP_APPLICATION_URL = 'https://www.ecetp.pdp.albany.edu/';
export const EIP_APPLICATION_SITE = 'www.ecetp.pdp.albany.edu';
